import { render } from "./IndividualOrganization.vue?vue&type=template&id=09d73d0e"
import script from "./IndividualOrganization.vue?vue&type=script&lang=js"
export * from "./IndividualOrganization.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__